const types = {
  UPDATE_TOKEN: 'UPDATE_TOKEN',
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  UPDATE_AGREEMENT_ID: 'UPDATE_AGREEMENT_ID',
  SET_LOADING: 'SET_LOADING',
  SET_CLUB_DATA: 'SET_CLUB_DATA',
  SET_AGREEMENT_CONTENT: 'SET_AGREEMENT_CONTENT',
  TOGGLE_AGGREEMENT: 'TOGGLE_AGGREEMENT',
  TOGGLE_WORKOUT_MODAL: 'TOGGLE_WORKOUT_MODAL',
  SET_CUSTOM_TRIGGER: 'SET_CUSTOM_TRIGGER',
}

export default types
